export default "/_next/static/images/switch-icon-71299ba02db4e901dbef56a271c47e1d.svg";